(function () {
  const TRACKED_EVENT = 'Added to Cart';
  const DEDUPE_WINDOW = 1500;

  let lastSignature = '';
  let lastTrackedAt = 0;

  const centsToAmount = (value) => {
    const amount = Number(value);
    return Number.isFinite(amount) ? amount / 100 : undefined;
  };

  const absoluteUrl = (url) => {
    if (!url) return undefined;
    try {
      return new URL(url, window.location.origin).toString();
    } catch (error) {
      return url;
    }
  };

  const normalizeItem = (item) => {
    if (!item) return null;

    const imageUrl = item.image || item.featured_image?.url || item.featured_image;
    const productUrl = item.url || item.product_url;
    const itemPrice = centsToAmount(item.final_price ?? item.price);
    const rowTotal = centsToAmount(item.final_line_price ?? item.line_price);

    return {
      ProductID: item.product_id,
      VariantID: item.variant_id || item.id,
      SKU: item.sku,
      ProductName: item.product_title || item.title,
      VariantName: item.variant_title,
      Quantity: Number(item.quantity) || 1,
      ItemPrice: itemPrice,
      RowTotal: rowTotal,
      ImageURL: absoluteUrl(imageUrl),
      URL: absoluteUrl(productUrl),
      ProductType: item.product_type,
      Vendor: item.vendor
    };
  };

  const compactObject = (object) => {
    return Object.entries(object).reduce((result, [key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        result[key] = value;
      }
      return result;
    }, {});
  };

  const findAddedItems = (detail, cartItems) => {
    const product = detail?.product;
    const variantId = String(detail?.productVariantId || '');

    if (variantId && Array.isArray(cartItems)) {
      const matchingItem = cartItems.find((item) => String(item.VariantID) === variantId);
      if (matchingItem) return [matchingItem];
    }

    if (Array.isArray(detail?.items) && detail.items.length > 0) {
      return detail.items.map(normalizeItem).filter(Boolean);
    }

    if (Array.isArray(product?.items)) {
      return product.items.map(normalizeItem).filter(Boolean);
    }

    if (product?.id || product?.variant_id) {
      return [normalizeItem(product)].filter(Boolean);
    }

    return [];
  };

  const buildPayload = (detail) => {
    const cart = detail?.cart && typeof detail.cart === 'object' ? detail.cart : null;
    const rawCartItems = Array.isArray(cart?.items) ? cart.items : [];
    const cartItems = rawCartItems.map(normalizeItem).filter(Boolean);
    const addedItems = findAddedItems(detail, cartItems);
    const primaryItem = addedItems[0] || cartItems[0] || null;

    if (!cart && !primaryItem) return null;

    return compactObject({
      $value: centsToAmount(cart?.total_price),
      CartTotal: centsToAmount(cart?.total_price),
      CartItemCount: cart?.item_count,
      CartURL: absoluteUrl('/cart'),
      AddedItemProductName: primaryItem?.ProductName,
      AddedItemProductID: primaryItem?.ProductID,
      AddedItemSKU: primaryItem?.SKU,
      AddedItemVariantID: primaryItem?.VariantID,
      AddedItemVariantName: primaryItem?.VariantName,
      AddedItemQuantity: primaryItem?.Quantity,
      AddedItemPrice: primaryItem?.ItemPrice,
      AddedItemURL: primaryItem?.URL,
      AddedItemImageURL: primaryItem?.ImageURL,
      AddedItems: addedItems,
      ItemNames: cartItems.map((item) => item.ProductName).filter(Boolean),
      Items: cartItems
    });
  };

  const getSignature = (payload) => {
    return [
      payload.AddedItemVariantID || '',
      payload.AddedItemQuantity || '',
      payload.CartItemCount || '',
      payload.CartTotal || '',
      window.location.pathname
    ].join('|');
  };

  const trackKlaviyoEvent = (payload) => {
    if (!payload) return;

    if (window.klaviyo && typeof window.klaviyo.track === 'function') {
      window.klaviyo.track(TRACKED_EVENT, payload).catch(() => {});
      return;
    }

    if (window.klaviyo && typeof window.klaviyo.push === 'function') {
      window.klaviyo.push(['track', TRACKED_EVENT, payload]);
      return;
    }

    window._learnq = window._learnq || [];
    window._learnq.push(['track', TRACKED_EVENT, payload]);
  };

  document.addEventListener('ajaxProduct:added', (event) => {
    const payload = buildPayload(event.detail || {});
    if (!payload) return;

    const signature = getSignature(payload);
    const now = Date.now();
    if (signature === lastSignature && now - lastTrackedAt < DEDUPE_WINDOW) return;

    lastSignature = signature;
    lastTrackedAt = now;
    trackKlaviyoEvent(payload);
  });
})();
